import {usePostHog} from 'posthog-js/react';

const usePostHogHook = () => {
  const posthog = usePostHog();
  const identifyUser = user => {
    const organization_id = user?.organizations ? user?.organizations[0]?.id : null;
    const organization_name = user?.organizations ? user?.organizations[0]?.name : null;
    // Optional: usePostHog() returns undefined when the provider is absent (analytics gated
    // off at build time). Login calls this, so an unguarded call would break sign-in.
    posthog?.identify(user.id, {
      email: user.email,
      ...(organization_id && { organization_id }),
      ...(organization_name && { organization_name }),
    });
  };
  return {posthog, identifyUser};
};

export default usePostHogHook;
